var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333344 4.4998L2.00001 6.16647C6.14168 2.02481 12.8583 2.02481 17 6.16647L18.6667 4.4998C13.6083 -0.558529 5.40001 -0.558529 0.333344 4.4998ZM7.00001 11.1665L9.50001 13.6665L12 11.1665C10.625 9.78314 8.38334 9.78314 7.00001 11.1665ZM3.66668 7.83314L5.33334 9.4998C7.63334 7.1998 11.3667 7.1998 13.6667 9.4998L15.3333 7.83314C12.1167 4.61647 6.89168 4.61647 3.66668 7.83314Z",
    fill: "#001230"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnLine);
export default __webpack_public_path__ + "static/media/on-line.45706e66df463900b13940ceca8a4634.svg";
export { ForwardRef as ReactComponent };